import { toValue, type MaybeRefOrGetter } from 'vue';

import type { AdsPlatformController } from '@/composables/platform/types';

import { useMetaAdsAccountDetails } from '@/composables/platform/useMetaAdsAccountDetails';
import { useTikTokAdsAccountDetails } from '@/composables/platform/useTikTokAdsAccountDetails';
import { CHANNELS } from '@/models/dashboards/channels.enum';

const CONTROLLER_FACTORIES = {
  [CHANNELS.META_ADS.value]: useMetaAdsAccountDetails,
  [CHANNELS.INSTAGRAM.value]: useMetaAdsAccountDetails,
  [CHANNELS.FACEBOOK.value]: useMetaAdsAccountDetails,
  [CHANNELS.TIKTOK_ADS.value]: useTikTokAdsAccountDetails,
  [CHANNELS.TIKTOK.value]: useTikTokAdsAccountDetails,
} as const;

type ControllerChannel = keyof typeof CONTROLLER_FACTORIES;

export function getAdsPlatformController(
  channel: MaybeRefOrGetter<string>,
): AdsPlatformController | null {
  const composable = CONTROLLER_FACTORIES[toValue(channel) as ControllerChannel];
  return composable ? composable() : null;
}
